// CampaignInfo.jsx
import React, { useRef, useEffect } from "react";
import "../../style/user/CampaignInfo.css";

export default function CampaignInfo({ campaign, onClose }) {
  const modalRef = useRef(null);
  const overlayRef = useRef(null);

  // Fungsi untuk mendapatkan display text status (sama dengan di CampaignList)
  const getStatusDisplayText = (status) => {
    switch (status) {
      case "on_process":
        return "Checking Campaign";
      case "success":
      case "completed":
        return "Campaign Success";
      case "failed":
        return "Campaign Failed";
      default:
        return status || "Unknown";
    }
  };

  // Fungsi untuk mendapatkan class badge status (sama dengan di CampaignList)
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "on_process":
        return "status-checking";
      case "success":
      case "completed":
        return "status-success";
      case "failed":
        return "status-failed";
      default:
        return "";
    }
  };

  // Handler untuk klik di luar modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Cek apakah onClose adalah function sebelum dipanggil
      if (typeof onClose === 'function') {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          onClose();
        }
      } else {
        console.warn('onClose is not a function');
      }
    };

    // Gunakan mousedown untuk mendeteksi klik di luar
    document.addEventListener("mousedown", handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  // Handler untuk close button
  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    } else {
      console.warn('onClose is not a function');
    }
  };

  // Handler untuk overlay click
  const handleOverlayClick = (e) => {
    // Pastikan yang diklik adalah overlay, bukan konten di dalamnya
    if (e.target === overlayRef.current && typeof onClose === 'function') {
      onClose();
    }
  };

  if (!campaign) return null;

  // Pastikan URL gambar absolute ke backend
  const imageUrl = campaign.image_url 
    ? `https://blasterprime.com${campaign.image_url.startsWith("/") ? campaign.image_url : "/" + campaign.image_url}` 
    : null;

  return (
    <div 
      className="campaign-info-overlay" 
      ref={overlayRef}
      onClick={handleOverlayClick}
    >
      <div 
        className="campaign-info-container" 
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="campaign-card">
          {/* Header dengan judul dan tombol close */}
          <div className="campaign-header">
            <h2 className="campaign-title">Campaign Info</h2>
            <button 
              className="campaign-close-btn" 
              onClick={handleClose} 
              title="Close"
              type="button"
            >
              ×
            </button>
          </div>

          {/* Banner */}
          {imageUrl && (
            <div className="campaign-banner">
              <img
                src={imageUrl}
                alt={campaign.campaign_name || "Campaign Banner"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/600x200?text=No+Image";
                }}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          )}

          {/* Campaign Details */}
          <div className="campaign-section">
            <h3>Campaign</h3>
            <div className="campaign-details">
              <p>
                ID Campaign:<strong>{Math.floor(new Date(campaign.created_at).getTime() / 1000)}</strong>
              </p>
              <p>
                Campaign Name:<strong> {campaign.campaign_name}</strong>
              </p>
              <p>
                Channel:<strong> {campaign.campaign_type}</strong>
              </p>
              <p>
                Status:{' '}
                <strong>
                  <span className={`status-badge ${getStatusBadgeClass(campaign.status)}`}>
                    {getStatusDisplayText(campaign.status)}
                  </span>
                </strong>
              </p>
              <p>
                Created At:<strong> {new Date(campaign.created_at).toLocaleString()}</strong>
              </p>
            </div>
          </div>

          {/* Message */}
          <div className="campaign-section">
            <h3>Campaign Message</h3>
            <p className="campaign-messages">
              <strong>{campaign.message}</strong>
            </p>
          </div>

          {/* Back Button */}
          <div className="button-container">
            <button className="back-button" onClick={handleClose} type="button">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}